module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAKCAYAAAC9vt6cAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAC7SURBVHgBnVHLDYMwDE2isgcjtCNw5iMyAhOUTtB2g3aDboCUz7kdISMwAvdISW2JSikKIHiXPNvvOXZCtdZH51xNdsB7bw5IKKVXsgPQoGF5nhuYoCEbAeZ7VVUvhgESTGwwP8uyvCGnYUFK+YB1zit+UxTF6RewsAJdWzg+C+beWsvDBJsqRkE/Y8445381GhGSruvSJEneQNMxNcBqGT74VMtiDfAWMOAkA8bwS5eYeRVCiFop1S5pvu3PSc7LiYf1AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/vector.png
// module id = Mz+O
// module chunks = 1